import systemSizeImg from "../components/assets/images/carousel/system-size-img.png";
import consumptionImg from "../components/assets/images/carousel/consumption-img.png";
import productionImg from "../components/assets/images/carousel/production-img.png";
import usageOffsetImg from "../components/assets/images/carousel/usage-offset-img.png";

import { CardCarouselData } from "providers/Types";
import { isBigTipText } from "utils/textUtils";

const productionTipText =
  "This is an estimate and does not guarantee actual system production. The system design may change based on a detailed engineering site survey. Actual system production will vary based on the final system size, design, and configuration.";

const systemSizeCardData = {
  headerText: "System Size",
  infoToolTipText: "",
  footerTextSuffix: "kW",
  iconMedia: systemSizeImg,
  extendedDescription: "",
} as CardCarouselData;
const productionCardData = {
  headerText: "Estimated annual production",
  infoToolTipText: productionTipText,
  footerTextSuffix: "kWh",
  iconMedia: productionImg,
  extendedDescription: "",
  isBigTip: isBigTipText(productionTipText),
} as CardCarouselData;
const consumptionCardData = {
  headerText: "Estimated annual consumption",
  infoToolTipText: "",
  footerTextSuffix: "kWh",
  iconMedia: consumptionImg,
  extendedDescription: "",
} as CardCarouselData;

const storageCapacityCardData = {
  headerText: "Storage Capacity",
  infoToolTipText: "",
  footerTextSuffix: "kWh",
  iconMedia: productionImg,
  extendedDescription: "",
} as CardCarouselData;

const maxPowerCardData = {
  headerText: "Max Power",
  infoToolTipText: "",
  footerTextSuffix: "kW",
  iconMedia: usageOffsetImg,
  extendedDescription: "",
} as CardCarouselData;

const backupTimeCardData = {
  headerText: "Power During Outage",
  infoToolTipText:
    "Storage add on and Standalone systems are configured to provide power in the case of a grid outage, which assumes that your battery is sufficiently charged at the time of the outage. Speak with your sales rep for further details.",
  iconMedia: consumptionImg,
} as CardCarouselData;

export {
  systemSizeCardData,
  productionCardData,
  consumptionCardData,
  storageCapacityCardData,
  maxPowerCardData,
  backupTimeCardData,
};
